import servers from "./servers";
import devices from "./devices";
import logs from "./logs";

export default {
  namespaced: true,
  modules: {
    servers,
    devices,
    logs
  }
};
